export const PORTUGUESE_LANGUAGE = {
    translation: {
        header: {
            items: [
                { name: 'Home', link: '/#home' },
                { name: 'Sobre mim', link: '/#about' },
                { name: 'Tecnologias', link: '/#services' },
                { name: 'Projetos', link: '/#portfolio' },
                { name: 'Contatos', link: '/#contact' },
            ]
        },
        home: {
            presentation: "Prazer,",
            whoIsIt: "Eu sou o Gabriel!",
            occupation: "Desenvolvedor Front-end",
            invite: "Vamos conversar",
            invitationLink: 'https://api.whatsapp.com/send?phone=5511960188549&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20voc%C3%AA.'
        },
        aboutMe: {
            title: "Sobre mim",
            firstSentence: "Sou desenvolvedor full stack, mas atualmente trabalho como desenvolvedor front-end na empresa Zenvia.",
            secondSentence: "Estou cursando ciência da computação na Anhembi Morumbi. Me formei em Sistemas de Informação na Etec de Embu das Artes",
            thirdSentence: "Na minha rotina utilizo essas tecnologias",
            resumeButton: 'Confira meu CV',
            linkMyResume: 'https://drive.google.com/file/d/1zHaM_zVSOqUQIS64-vLfyWsSasH2bLu-/view?usp=sharing'
        },
        technologies: {
            title: 'Tecnologias',
            subtitle: 'Confira as tecnologias que mais utilizo',
            listTechnologies: [
                { id: '1', name: 'Next JS', description: 'Framework React com foco em produção e eficiência, criado e mantido pela Vercel.' },
                { id: '2', name: 'TypeScript', description: 'Adiciona sintaxe ao JavaScript para integração com o editor e detecção de erros desde cedo.' },
                { id: '3', name: 'Sass', description: 'Pré-processador CSS. Totalmente compatível com todas as versões do CSS.' },
                { id: '4', name: 'React Js', description: 'Biblioteca para construir interfaces de usuário (UI).' },
                { id: '5', name: 'React Native', description: 'Framework para desenvolvimento nativo de aplicativos Android e iOS.' },
                { id: '6', name: 'PostgreSQL', description: 'Banco de dados objeto-relacional open source, com SQL, ACID e alta extensibilidade.' },
                { id: '7', name: 'MySQL', description: 'Banco de dados open source mais popular. Performance, confiabilidade e facilidade de uso para aplicações web.' },
                { id: '8', name: 'MongoDB', description: 'Banco de documentos com dados em formato flexível tipo JSON, escalabilidade horizontal e alta disponibilidade.' },
                { id: '9', name: 'NestJS', description: 'Framework para aplicações Node.js escaláveis no servidor, com TypeScript e arquitetura pronta.' },
                { id: '10', name: 'Docker', description: 'Plataforma aberta para desenvolver, entregar e executar aplicações em containers leves e isolados.' },
                { id: '11', name: 'CI/CD', description: 'Prática que automatiza build, testes e deploy para entregas mais rápidas e confiáveis.' },
                { id: '12', name: 'GraphQL', description: 'Linguagem de consulta e runtime para APIs. Permite APIs flexíveis com sistema de tipos forte.' },
                { id: '13', name: 'Kubernetes', description: 'Plataforma open source para orquestrar cargas em containers, com configuração declarativa e automação.' },
                { id: '14', name: 'Monorepo (Nx/Turborepo)', description: 'Ferramentas para monorepos: cache de tarefas, orquestração inteligente e execução paralela.' },
                { id: '15', name: 'Serverless', description: 'Execução de código sem provisionar servidores; escalonamento automático e pagamento por uso.' },
                { id: '16', name: 'Micro frontends', description: 'Arquitetura em que frontends são desenvolvidos e implantados de forma independente e compostos em uma aplicação.' },
                { id: '17', name: 'AWS', description: 'Plataforma de nuvem mais adotada do mundo. Computação, armazenamento, bancos de dados e mais de 200 serviços sob demanda em escala.' },
            ]
        },
        projects: {
            title: 'Projetos pessoais',
            subtitle: 'Confira meus projetos',
        },
        contact: {
            title: 'Contatos',
            subtitle: 'Entre em contato para começarmos',
            location: 'Localização',
            email: 'Email',
            phone: 'Telefone',
        },
        network: {
            title: 'Onde me encontrar'
        }
    }
};
